<template>
  <LcHeader
    v-bind="{ leftButtonIcon, withFlyOut }"
    :fly-out-toggle-aria-label="$t('scratchcard.header.button.flyout')"
    fly-out-toggle-class="paragraph-bold"
    @left-button-click="handleClick"
  >
    <template #headline>
      <ScratchcardTitle v-bind="{ color, title }" />
    </template>

    <template #fly-out-toggle>
      {{ chargeTotal }}
    </template>

    <template #fly-out-content>
      <PriceList v-if="priceListProps" v-bind="priceListProps">
        <ScratchcardPriceBreakdownList />
      </PriceList>
    </template>
  </LcHeader>
</template>

<script lang="ts" setup>
import type { LcHeaderProps } from '@lottocom/frontend-components'

import Money from '~~/models/Money'

import { useScratchcardStore } from '../stores/scratchcard'

type ScratchcardHeaderProps = Pick<LcHeaderProps, 'leftButtonIcon' | 'withFlyOut'> & {
  onClick?: () => void
}

const { leftButtonIcon = 'arrow-left', onClick, withFlyOut } = defineProps<ScratchcardHeaderProps>()

const { name, priceList, visualParameters } = useScratchcardGame()
const { currentPrice } = useScratchcardStore()
const { back, chargeTotal } = usePriceBreakdownHeader(
  computed(() => currentPrice(priceList.value)),
  withFlyOut,
)

const color = computed(() => visualParameters.value?.titleColor)
const title = computed(() => name.value || '')

const priceListProps = computed(() => {
  if (!priceList.value) return null
  const price = currentPrice(priceList.value)
  if (!price || !chargeTotal.value) return null

  const { feesForCards, salesTax } = price

  return {
    chargeTotal: new Money(price.chargeTotal ?? 0),
    convenienceFee: new Money(feesForCards),
    salesTax: new Money(salesTax),
    showSalesTax: (salesTax.value ?? 0) > 0,
  }
})

const handleClick = () => {
  if (onClick) return onClick()
  back()
}
</script>
